import React, { forwardRef, useEffect } from 'react'

import { QuizContextType } from '@f/applications/QuizApp/context/QuizContext'
import CTA from '@f/elements/CTA'

import { Data } from '@f-fertighaus/applications/RequestWizard/steps/dataType'

interface QuizDebounceModalProps {
  closeModal: () => void
  flow: QuizContextType['tracking']['flow']
  config: Data['debounceModal']
}

const MODAL_ID = 'debounce-modal'

export const QuizDebounceModal = forwardRef(function QuizDebounceModal(
  { flow, config, closeModal }: QuizDebounceModalProps,
  ref
) {
  useEffect(() => {
    window._wt({
      category: 'modal',
      action: 'display',
      values: [
        {
          type: 'name',
          value: MODAL_ID
        }
      ],
      ...flow
    })

    return () => {
      window._wt({
        category: 'modal',
        action: 'hide',
        values: [
          {
            type: 'name',
            value: MODAL_ID
          }
        ],
        ...flow
      })
    }
  }, [flow])

  return (
    <div
      className='[ f-c-ba-whi f-radius-card-large f-p-a-040 ] Quiz-modal'
      ref={ref}>
      <span className='[ f-d-bl f-t-tminor ]'>{config.title}</span>
      <p
        className='[ f-t-body f-m-a-0 f-m-t-020 ]'
        dangerouslySetInnerHTML={{ __html: config.description }}
      />
      {config.primaryCta && (
        <CTA
          type='block-primary'
          className='[ f-m-t-020 ] is-full-width'
          onClick={closeModal}
          wtData={{
            'CTA-click': {
              location: MODAL_ID,
              ...flow
            }
          }}
          {...(config.primaryCta.link && {
            href: config.primaryCta.link,
            tag: 'a'
          })}>
          {config.primaryCta.copy}
        </CTA>
      )}
      {config.secondaryCta && (
        <CTA
          type='text-primary'
          className='[ f-m-t-020 ] is-full-width f-t-body'
          onClick={closeModal}
          wtData={{
            'CTA-click': {
              location: MODAL_ID,
              ...flow
            }
          }}
          {...(config.secondaryCta.link && {
            href: config.secondaryCta.link,
            tag: 'a'
          })}>
          {config.secondaryCta.copy}
        </CTA>
      )}
    </div>
  )
})
